const COUNTRY_CONFIGURATIONS = {
    US_LIKE_COUNTRIES: ['US', 'CA', 'PR'],
    MOBILE_ONLY_COUNTRIES: ['AU', 'AT', 'DE', 'ZA', 'FR', 'DK', 'BE', 'GB', 'FI', 'IL', 'NL']
  };
  
  interface PhoneNumberPayload {
    countryISO: string;
    poolSize: number;
    action: 'custom' | 'tollfree' | string;
    areaCode?: string;
  }
  
  interface AvailableNumbersParams {
    trackingNumbers: number;
    countryCode: string;
    numberTypes: string[];
    smsEnabled: boolean;
    mmsEnabled: boolean;
    voiceEnabled: boolean;
    firstPart?: string;
  }

  function getPhoneNumberCapabilities(countryISO: string, action: string): {
    smsEnabled: boolean;
    mmsEnabled: boolean;
    voiceEnabled: boolean;
  } {
    const isUSLike = COUNTRY_CONFIGURATIONS.US_LIKE_COUNTRIES.includes(countryISO);
    const isMobileOnly = COUNTRY_CONFIGURATIONS.MOBILE_ONLY_COUNTRIES.includes(countryISO);
    const isTollFree = action === 'tollfree';
  
    // Default all features enabled for US-like countries
    if (isUSLike) {
      return {
        smsEnabled: !isTollFree,
        mmsEnabled: !isTollFree,
        voiceEnabled: true
      };
    }
  
    // Mobile-only countries support SMS but not MMS
    if (isMobileOnly) {
      return {
        smsEnabled: !isTollFree,
        mmsEnabled: false,
        voiceEnabled: true
      };
    }
  
    // For all other countries, only voice is enabled by default
    return {
      smsEnabled: false,
      mmsEnabled: false,
      voiceEnabled: true
    };
  }
  
  function getNumberTypes(countryISO: string, action: string): string[] {
    if (action === 'tollfree') {
      return ['tollFree'];
    }
  
    const isMobileOnly = COUNTRY_CONFIGURATIONS.MOBILE_ONLY_COUNTRIES.includes(countryISO);
    
    if (isMobileOnly) {
      return ['mobile', 'local']; // Try mobile first, then local as fallback
    }
  
    return ['local'];
  }
  
  export function transformToNewPayload(payload: PhoneNumberPayload): AvailableNumbersParams {
    const { countryISO, poolSize, action, areaCode } = payload;
    
    const capabilities = getPhoneNumberCapabilities(countryISO, action);
    const numberTypes = getNumberTypes(countryISO, action);
  
    return {
      trackingNumbers: poolSize,
      countryCode: countryISO,
      numberTypes,
      firstPart: areaCode,
      ...capabilities
    };
  }